<script setup lang="ts">
import type {
  CompositeFilterDescriptor,
  FilterDescriptor,
} from "@progress/kendo-data-query";
import { onMounted, watchEffect } from "vue";

const props = defineProps<{
  filter: CompositeFilterDescriptor;
}>();

const defaultClassName = "k-icon k-svg-icon k-svg-i-more-vertical";

const updateColumnMenuIcons = function () {
  if (!props.filter) return;

  // find all k-grid-column-menu elements
  const columnMenus = Array.from(
    document.querySelectorAll(".k-grid-column-menu")
  );

  props.filter.filters.forEach((f) => {
    const cf = f as CompositeFilterDescriptor;
    if (!cf.filters) return;
    const columnName = (cf.filters[0] as FilterDescriptor).field;

    // find k-icon of k-grid-column-menu with column name as a title
    const columnMenu = columnMenus.find(
      (cm) => (cm as HTMLElement).title === `${columnName} Column Menu`
    );

    if (!columnMenu) return;

    const menuIcon = columnMenu.querySelector(".k-icon");

    if (!menuIcon) return;

    // Replace menu icon with k-i-filter-sm
    menuIcon.className = defaultClassName + " active";

    columnMenus.splice(columnMenus.indexOf(columnMenu), 1);
  });

  // Replace remaining menu icons with k-i-more-vertical (default icon)
  columnMenus.forEach((cm) => {
    const menuIcon = cm.querySelector(".k-icon");

    if (!menuIcon) return;

    menuIcon.className = defaultClassName;
  });
};

defineExpose({
  updateColumnMenuIcons,
});

watchEffect(() => {
  updateColumnMenuIcons();
});

onMounted(() => {
  updateColumnMenuIcons();
});
</script>

<style lang="scss">
.k-icon.active {
  color: #007bff;
}
</style>
